import React from "react";
import SectionHeader from "../section/SectionHeader.js";
import kitchenBg from "../../../assets/images/banner-back-1.jpg";
import KitchenImg from "../../../assets/images/kitc-12.jpg";
import BathroomImg from "../../../assets/images/bath3.jpg";
import BedroomIMg from "../../../assets/images/home8.jpg";
import LeavingroomImg from "../../../assets/images/bm7.jpg";


const WorkPortfolio = () => {
  return (
    <>
      <div className="container-fluid mt-3">
        <SectionHeader title="Work Portfolio" backgroundImage={kitchenBg} />
        
        <div className="container-fluid  py-4 mb-4">
  <div className="row g-3">
    {[
      {
        src: KitchenImg,
        alt: "Kitchen Renovations",
        href: "/kitchen-renovations",
        title: "Kitchen Renovations",
      },
      {
        src: BathroomImg,
        alt: "Bathroom Renovations",
        href: "/bathroom-renovation",
        title: "Bathroom Renovations",
      },
      {
        src: BedroomIMg,
        alt: "Home Extensions",
        href: "/home-renovation",
        title: "Home Extensions",
      },
      {
        src: LeavingroomImg,
        alt: "Basement Renovations",
        href: "/basement-renovation",
        title: "Basement Renovations",
      },
    ].map((item, index) => (
      <div className="col-12 col-sm-6 col-md-6 col-lg-3" key={index}  >
        <a href={item.href} className="text-decoration-none text-dark">
          <div data-sal="slide-right" data-sal-duration="2000" data-sal-delay="300"
            className="position-relative  overflow-hidden"
            style={{ height: "320px", width: "100%" }}
          >
            <img
              src={item.src}
              alt={item.alt}
              className="w-100 h-100"
              style={{ objectFit: "cover", display: "block" }}
            />
            <div
              className="position-absolute bg-white px-3 py-2 shadow-sm"
              style={{ bottom: "16px", left: "16px",opacity:"0.9" }}
            >
              <strong>{item.title} &rarr;</strong>
            </div>
          </div>
        </a>
      </div>
    ))}
  </div>
</div>




        </div>
      
    </>
  );
};

export default WorkPortfolio;
